import { EventEmitter } from '@angular/core';
import { GAMES_CONFIG } from "../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../loader.service";
var GamesPlaygroundService = /** @class */ (function () {
    function GamesPlaygroundService(http, loaderService) {
        this.http = http;
        this.loaderService = loaderService;
        this.config = GAMES_CONFIG;
        this.games = [];
        this.updateGames = new EventEmitter();
        this.onGamesUpdated = new EventEmitter();
    }
    GamesPlaygroundService.prototype.getPageInfo = function (game_short_name) {
        //this.loaderService.show();
        return this.http.post(this.config.getPageInfo, { game_short_name: game_short_name });
    };
    GamesPlaygroundService.prototype.setGames = function (games) {
        this.games = games;
    };
    GamesPlaygroundService.prototype.getGames = function () {
        return this.games.filter(function (game) { return !game.default; });
    };
    GamesPlaygroundService.prototype.getSelectedProvider = function () {
        if (this.games.length) {
            return this.games.find(function (game) { return game.default; });
        }
        return {};
    };
    GamesPlaygroundService.prototype.getSelectedProviderId = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().id) {
            return this.getSelectedProvider().id;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderName = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().name) {
            return this.getSelectedProvider().name;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderShortName = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().short_name) {
            return this.getSelectedProvider().short_name;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderAccount = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().account) {
            return this.getSelectedProvider().account;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderPassword = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().password) {
            return this.getSelectedProvider().password;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderGDPassword = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().gd_password) {
            return this.getSelectedProvider().gd_password;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderPin = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().pin) {
            return this.getSelectedProvider().pin;
        }
    };
    GamesPlaygroundService.prototype.getSelectedProviderMobileId = function () {
        if (this.getSelectedProvider() && this.getSelectedProvider().gd_mobile_id) {
            return this.getSelectedProvider().gd_mobile_id;
        }
    };
    GamesPlaygroundService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GamesPlaygroundService_Factory() { return new GamesPlaygroundService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoaderService)); }, token: GamesPlaygroundService, providedIn: "root" });
    return GamesPlaygroundService;
}());
export { GamesPlaygroundService };
